<template>
  <div>
    <div id="maychar" style="  width: 100%;
  height: 300px;"></div>
  </div>
</template>

<script>
import * as echarts from 'echarts';
export default {
  data() {
    return {
      option: {
        title: {
          text: '最近七天学习概览',
        //   show:false
        
       padding: [10, 0, 20, 20]   // 分别为上、右、下、左的边距值
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: null, // 默认为直线，可选为：'line' | 'shadow'
          },
          formatter: '<div style="text-align: center;">最近七天学习概览</div>{b} : {c}',
        },
        grid: {
          left: '3%',
          right: '4%',
          top: '10%',
          height: 280, //设置grid高度
          containLabel: true,
        },
        xAxis: [
          {
            type: 'value',
            axisLabel: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLine: {
              show: false,
            },
            splitLine: {
              show: false,
            },
          },
        ],
        yAxis: [
          {
            type: 'category',
            boundaryGap: true,
            axisTick: {
              show: false,
            },
            axisLabel: {
              interval: null,
            },
            axisLine: {
              // Y轴线相关配置
              show: false, // 不显示Y轴线
            },

            data: ['02/02', '02/01', '01/31', '01/30', '01/29', '01/28', '01/27'],
            splitLine: {
              show: false,
            },
          },
        ],
        series: [
          {
            name: '流量',
            type: 'bar',
            barWidth: 25,
            label: {
              normal: {
                show: true,
                position: 'right',
              },
            },

            itemStyle: {
              normal: {
                color: '#5DB461',
              },
            },
            data: [160, 170, 240, 264, 300, 520, 610],
          },
        ],
      },
    };
  },

  created(){

  },
  mounted(){
    this.getCharts();
  },
  methods:{
    getCharts(){
            console.log(echarts)
          const chartBox = echarts.init(document.getElementById("maychar"));
           let option  = this.option;
          chartBox.setOption(option);
          // 根据页面大小自动响应图表大小
          window.addEventListener("resize", function () {
          chartBox.resize();
        });
    },
   
  }
};
</script>

<style scoped></style>
